import React from 'react'

const Button = (props) => {
  return (
    <div>
        <button className='px-6 py-1 border
                        bg-primary dark:bg-darkprimary text-darktext dark:text-text hover:bg-primary/90 dark:hover:bg-darkprimary/90
                          transition-all rounded-full'>
            {props.title}
        </button>
    </div>
  )
}

export default Button